<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.4 14.55">
    <path
        d="M7.15 14.39a7.11 7.11 0 117.12-7.11 7.11 7.11 0 01-7.12 7.11zm0-12.72a5.61 5.61 0 105.62 5.61 5.61 5.61 0 00-5.62-5.61zM10.3 7H8V3.23H6.53v5.25h3.77z"
        fill="#2c3d50" />
</svg>